import './icons.js'
import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default function Header() {
    return (
        <>
            <header data-side-pin="" data-side-pin-global="--menu-global-pad">
                <a href="Home">
                    <span class="logo">
                        {/* <img class="no-mobile" src="images/logo.png" /> */}
                        <div>
                            <img class="mobile-only" src="images/big-logo.png" />
                            <img class="mobile-only m-logo" src="images/big-logo-b.png" />
                        </div>
                    </span>
                </a>
                <div class="mega-menu">
                    <div class="content">
                        <div class="nucoin">
                            <a href="nucoin">
                                <span>NuCoin</span>
                            </a>
                        </div>
                        {/* <div class="ledgerx">
                            <a href="Ledgerx">
                                <span>LedgerX</span>
                            </a>
                        </div>
                        <div class="insidecrypto">
                            <a href="insidecrypto">
                                <span>InsideCrypto</span>
                            </a>
                        </div> */}
                        <div class="roadmap">
                            <a href="roadmap">
                                <span>Roadmap</span>
                            </a>
                        </div>
                        {/* <div class="facebook">
                            <a href="facebook">
                                <span>Facebook</span>
                            </a>
                        </div> */}

                        <div data-dropdown="hover" class="defi">
                            <span>Products</span>
                            <div data-dropdown-content="">
                                <div class="menu-frame">
                                    <div class="content">
                                        <div class="preview">
                                            <div class="title">Products</div>
                                            <div class="text"></div>
                                            <div class="btns">
                                            </div>
                                        </div>

                                        <div class="link-group">
                                            <a href="Ledgerx">
                                                <div class="title">
                                                    <FontAwesomeIcon icon="robot" className="purple-icon" />
                                                    <span>LedgerX</span>
                                                    <div class="decor"></div>
                                                </div>
                                                <div class="text">
                                                </div>
                                            </a>

                                            <a href="insidecrypto">
                                                <div class="title">
                                                    <FontAwesomeIcon icon="balance-scale" className="purple-icon" />
                                                    <span>InsideCrypto</span>
                                                    <div class="decor"></div>
                                                </div>
                                                <div class="text">
                                                  
                                                </div>
                                            </a>

                                            <a href="explorer">
                                                <div class="title">
                                                    <FontAwesomeIcon icon="chart-line" className="purple-icon" />
                                                    <span>Explorer</span>
                                                    <div class="decor"></div>
                                                </div>
                                                <div class="text">
                                                
                                                </div>
                                            </a>

                                        </div>


                                        <div class="link-group">
                                            <a href="explorer_transection">
                                                <div class="title">
                                                    <FontAwesomeIcon icon="file-alt" className="purple-icon" />
                                                    <span>NuCoin 1 Explorer History</span>
                                                    <div class="decor"></div>
                                                </div>
                                                <div class="text">
                                                </div>
                                            </a>

                                             <a href="sell_nuc">
                                                <div class="title">
                                                    <FontAwesomeIcon icon="coins" className="purple-icon" />
                                                    <span>Sell NUC</span>
                                                    <div class="decor"></div>
                                                </div>
                                                <div class="text">
                                                  
                                                </div>
                                            </a>

                                            {/*<a href="explorer">
                                                <div class="title">
                                                    <FontAwesomeIcon icon="coins" className="purple-icon" />
                                                    <span>Explorer</span>
                                                    <div class="decor"></div>
                                                </div>
                                                <div class="text">
                                                
                                                </div>
                                            </a> */}

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>


                        <div data-dropdown="hover" class="web3back">
                            <span>About Us</span>
                            <div data-dropdown-content="">
                                <div class="menu-frame">
                                    <div class="content">
                                        <div class="preview" >

                                            <div class="title">About {process.env.REACT_APP_PROJECT_NAME}</div>
                                            <div class="text">
                                                {process.env.REACT_APP_PROJECT_NAME} is system of blockchain technologies to reap the potential in the mass adoption of the crypto market. It integrates blockchain load balancers and system validators to efficiently flow data into infinite parallel processing blockchains. The more users, the faster the transaction speed!
                                            </div>
                                            <div class="btns">
                                                <a href="About" class="btn-sm">View</a>
                                            </div>
                                        </div>

                                        <div class="link-group">
                                            <a href="Projects">
                                                <div class="title">
                                                    <FontAwesomeIcon icon="puzzle-piece" className="light-blue" />

                                                    <span>Projects</span>
                                                    <div class="decor"></div>
                                                </div>
                                                <div class="text">
                                                    NuCoin is the native currency in the {process.env.REACT_APP_PROJECT_NAME} ecosystem. </div>
                                            </a>
                                             <a href="Facebook">
                                                <div class="title">
                                                    <div class="img-frame"><img src="images/2.svg" alt="" /></div>
                                                    <span>Facebook</span>
                                                    <div class="decor"></div>
                                                </div>
                                                <div class="text">
                                                   
                                                </div>
                                            </a>
                                           {/* <a href="#">
                                                <div class="title">
                                                    <div class="img-frame"><img src="images/3.svg" alt="" /></div>
                                                    <span>Getting Involved</span>
                                                    <div class="decor"></div>
                                                </div>
                                                <div class="text">
                                                    Want to join the {process.env.REACT_APP_PROJECT_NAME} Community?
                                                </div>
                                            </a>
                                            <a href="#">
                                                <div class="title">
                                                    <div class="img-frame"><img src="images/3.svg" alt="" /></div>
                                                    <span>Opportunities</span>
                                                    <div class="decor"></div>
                                                </div>
                                                <div class="text">
                                                    Explore out of this world opportunities with {process.env.REACT_APP_PROJECT_NAME}
                                                </div>
                                            </a> */}
                                        </div>



                                    </div>
                                </div>
                            </div>
                        </div>



                        <div data-dropdown="hover" class="defi">
                            <span>AI Application</span>
                            <div data-dropdown-content="">
                                <div class="menu-frame">
                                    <div class="content">
                                        <div class="preview" >
                                            <div class="title">AI Application</div>
                                            <div class="text">AI applications automate tasks using machine learning, NLP, vision, and data analysis.</div>
                                            <div class="btns">
                                            </div>
                                        </div>

                                        <div class="link-group">
                                            <a href="CryptoInsightsBot">
                                                <div class="title">
                                                    <FontAwesomeIcon icon="robot" className="purple-icon" />
                                                    <span>Crypto Insights Bot</span>
                                                    <div class="decor"></div>
                                                </div>
                                                <div class="text">
                                                    {/* AI-powered crypto forecasts, trends, and trading signals. */}
                                                    </div>
                                            </a>

                                            <a href="crypto_compare">
                                                <div class="title">
                                                    <FontAwesomeIcon icon="cubes" className="purple-icon" />
                                                    <span>Crypto Compare</span>
                                                    <div class="decor"></div>
                                                </div>
                                                <div class="text">
                                                    {/* Compare crypto trends, prices, and predictions in real-time. */}
                                                </div>
                                            </a>

                                            <a href="textanalyze">
                                                <div class="title">
                                                    <FontAwesomeIcon icon="coins" className="purple-icon" />
                                                    <span>AI Detector</span>
                                                    <div class="decor"></div>
                                                </div>
                                                <div class="text">
                                                    {/* AI Detector and get a detailed report on how AI tools may have been used to create the content. */}
                                                    </div>
                                            </a>

                                            <a href="fitness">
                                                <div class="title">
                                                    <FontAwesomeIcon icon="dumbbell" className="purple-icon" />
                                                    <span>AI Fitness</span>
                                                    <div class="decor"></div>
                                                </div>
                                                <div class="text">
                                                    {/* AI Fitness and get a detailed report on how AI tools may have been used to create the content. */}
                                                    </div>
                                            </a>

                                        </div>

                                        <div class="link-group">
                                            <a href="InsightsCryptoNewsHub">
                                                <div class="title">
                                                    <FontAwesomeIcon icon="file-alt" className="purple-icon" />
                                                    <span>InsideCrypto News Hub</span>
                                                    <div class="decor"></div>
                                                </div>
                                                <div class="text">
                                                </div>
                                            </a>

                                            <a href="dreamInterpretation">
                                                <div class="title">
                                                    <FontAwesomeIcon icon="laptop-code" className="purple-icon" />
                                                    <span>Dream Interpretation</span>
                                                    <div class="decor"></div>
                                                </div>
                                                <div class="text">
                                                </div>
                                            </a>

                                            <a href="digitalkyc">
                                                <div class="title">
                                                    <FontAwesomeIcon icon="id-card" className="purple-icon" />
                                                    <span>Digital kyc</span>
                                                    <div class="decor"></div>
                                                </div>
                                                <div class="text">
                                                </div>
                                            </a>

                                            <a href="tutor">
                                                <div class="title">
                                                    <FontAwesomeIcon icon="chalkboard-teacher" className="purple-icon" />
                                                    <span>AI Tutor</span>
                                                    <div class="decor"></div>
                                                </div>
                                                <div class="text">
                                                </div>
                                            </a>

                                        </div>

                                        <div class="link-group">
                                            <a href="textsummarize">
                                                <div class="title">
                                                    <FontAwesomeIcon icon="eye" className="purple-icon" />
                                                    <span>AI Text Summarizer</span>
                                                    <div class="decor"></div>
                                                </div>
                                                <div class="text">
                                                    {/* AI text summarizer condenses content using NLP, machine learning, extractive, and abstractive methods. */}
                                                     </div>
                                            </a>

                                            <a href="textparaphrase">
                                                <div class="title">
                                                    <FontAwesomeIcon icon="microchip" className="purple-icon" />
                                                    <span>AI Text Paraphrasing</span>
                                                    <div class="decor"></div>
                                                </div>
                                                <div class="text">
                                                    {/* Paraphrase text easily with AI for better clarity and style. */}
                                                    </div>
                                            </a>

                                            <a href="textgrammer">
                                                <div class="title">
                                                    <FontAwesomeIcon icon="brain" className="purple-icon" />
                                                    <span>AI Grammar Checker</span>
                                                    <div class="decor"></div>
                                                </div>
                                                <div class="text">
                                                    {/* Free AI grammar checker for professionals to fix writing errors */}
                                                    </div>
                                            </a>

                                            <a href="chefmate">
                                                <div class="title">
                                                    <FontAwesomeIcon icon="utensils" className="purple-icon" />
                                                    <span>ChefMate</span>
                                                    <div class="decor"></div>
                                                </div>
                                                <div class="text">
                                                    {/* AI-powered cooking assistant for recipe suggestions and meal planning */}
                                                    </div>
                                            </a>

                                        </div>

                                        <div class="link-group">
                                            <a href="deepfake">
                                                <div class="title">
                                                    <FontAwesomeIcon icon="mask" className="purple-icon" />
                                                    <span>Deepfake</span>
                                                    <div class="decor"></div>
                                                </div>
                                                <div class="text">
                                                </div>
                                            </a>

                                            <a href="cryptotutor">
                                                <div class="title">
                                                    <FontAwesomeIcon icon="chart-line" className="purple-icon" />
                                                    <span>Crypto Trading Tutor</span>
                                                    <div class="decor"></div>
                                                </div>
                                                <div class="text">
                                                </div>
                                            </a>

                                            <a href="lawyer">
                                                <div class="title">
                                                    <FontAwesomeIcon icon="balance-scale" className="purple-icon" />
                                                    <span>AI Lawyer</span>
                                                    <div class="decor"></div>
                                                </div>
                                                <div class="text">

                                                </div>
                                            </a>

                                           
                                            <a href="chatscraper">
                                                <div class="title">
                                                    <FontAwesomeIcon icon="shield-alt" className="purple-icon" />
                                                    <span>Chat Scraper</span>
                                                    <div class="decor"></div>
                                                </div>
                                                <div class="text">

                                                </div>
                                            </a>

                                            <a href="chatty">
                                                <div class="title">
                                                    <FontAwesomeIcon icon="robot" className="purple-icon" />
                                                    <span>Chatty</span>
                                                    <div class="decor"></div>
                                                </div>
                                                <div class="text">

                                                </div>
                                            </a>

                                        </div>

                                        {/* <div class="link-group">
                                    
                                </div>

                                <div class="link-group">
                                    
                                </div> */}

                                    </div>
                                </div>
                            </div>
                        </div>


                        <div data-dropdown="hover" class="web3back">
                            <span>{process.env.REACT_APP_PROJECT_NAME} Pitch Deck</span>
                            <div data-dropdown-content="">
                                <div class="menu-frame">
                                    <div class="content">
                                        {/* <div class="preview" >

                                            <div class="title">{process.env.REACT_APP_PROJECT_NAME} Pitch Deck</div>
                                            <div class="text">

                                            </div>


                                        </div> */}

                                        <div class="link-group">
                                            <a href="community">
                                                <div class="title">
                                                    <FontAwesomeIcon icon="shield-alt" className="light-blue" />
                                                    <span>NuGensis Community </span>
                                                    <div class="decor"></div>
                                                </div>
                                                <div class="text">
                                                    {/* NuGensis Community Ownership NFT Design Philosophy */}
                                                </div>
                                            </a>

                                            <a href="valuation_report">
                                                <div class="title">
                                                    <FontAwesomeIcon icon="chart-line" className="light-blue" />
                                                    <span>Valuation Report</span>
                                                    <div class="decor"></div>
                                                </div>
                                                <div class="text">

                                                </div>
                                            </a>
                                            <a href="pdg">
                                                <div class="title">
                                                    <FontAwesomeIcon icon="file-powerpoint" className="light-blue" />
                                                    <span>Pitch Deck Guide</span>
                                                    <div class="decor"></div>
                                                </div>
                                                <div class="text">

                                                </div>
                                            </a>


                                        </div>



                                        <div class="link-group">
                                            <a href="ti_department">
                                                <div class="title">
                                                    <FontAwesomeIcon icon="laptop-code" className="light-blue" />
                                                    <span>Technology Innovations Department</span>
                                                    <div class="decor"></div>
                                                </div>
                                                <div class="text">
                                                    {/* Building for the future */}
                                                </div>
                                            </a>

                                            <a href="medical">
                                                <div class="title">
                                                    <FontAwesomeIcon icon="vial" className="light-blue" />
                                                    <span>Medical Field</span>
                                                    <div class="decor"></div>
                                                </div>
                                                <div class="text">

                                                </div>
                                            </a>
                                            <a href="ai_department">
                                                <div class="title">
                                                    <FontAwesomeIcon icon="robot" className="light-blue" />
                                                    <span>Artificial Innovation Department</span>
                                                    <div class="decor"></div>
                                                </div>
                                                <div class="text">

                                                </div>
                                            </a>


                                        </div>


                                        <div class="link-group">
                                            <a href="summary">
                                                <div class="title">
                                                    <FontAwesomeIcon icon="file-alt" className="light-blue" />
                                                    <span>Summary And Rejuvenation Plan</span>
                                                    <div class="decor"></div>
                                                </div>
                                                <div class="text">

                                                </div>
                                            </a>

                                            <a href="nft">
                                                <div class="title">
                                                    <FontAwesomeIcon icon="coins" className="light-blue" />
                                                    <span>NFTS</span>
                                                    <div class="decor"></div>
                                                </div>
                                                <div class="text">

                                                </div>
                                            </a>
                                            <a href="prediction">
                                                <div class="title">
                                                    <FontAwesomeIcon icon="chart-pie" className="light-blue" />
                                                    <span>Prediction & Analytics</span>
                                                    <div class="decor"></div>
                                                </div>
                                                <div class="text">

                                                </div>
                                            </a>


                                        </div>


                                        <div class="link-group">
                                            <a href="media_stream">
                                                <div class="title">
                                                    <FontAwesomeIcon icon="tv" className="light-blue" />
                                                    <span>Media Stream</span>
                                                    <div class="decor"></div>
                                                </div>
                                                <div class="text">

                                                </div>
                                            </a>

                                            <a href="business_resources">
                                                <div class="title">
                                                    <FontAwesomeIcon icon="cubes" className="light-blue" />
                                                    <span>Business Resources</span>
                                                    <div class="decor"></div>
                                                </div>
                                                <div class="text">

                                                </div>
                                            </a>
                                            <a href="videos">
                                                <div class="title">
                                                    <FontAwesomeIcon icon="video" className="light-blue" />
                                                    <span>Videos Series</span>
                                                    <div class="decor"></div>
                                                </div>
                                                <div class="text">

                                                </div>
                                            </a>


                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>



                        {/* <div data-dropdown="hover" class="defi">
                            <span>Wallets</span>
                            <div data-dropdown-content="">
                                <div class="menu-frame">
                                    <div class="content">
                                        <div class="preview">
                                            <div class="title">Wallets</div>
                                            <div class="text"></div>
                                            <div class="btns">
                                            </div>
                                        </div>

                                        <div class="link-group">
                                            <a href="#">
                                                <div class="title">
                                                    <FontAwesomeIcon icon="robot" className="purple-icon" />
                                                    <span>Trust Wallet</span>
                                                    <div class="decor"></div>
                                                </div>
                                                <div class="text">
                                                </div>
                                            </a>

                                            <a href="#">
                                                <div class="title">
                                                    <FontAwesomeIcon icon="balance-scale" className="purple-icon" />
                                                    <span>Fireblocks Wallet</span>
                                                    <div class="decor"></div>
                                                </div>
                                                <div class="text">

                                                </div>
                                            </a>

                                            

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div> */}

                    </div>
                </div>

                <div class="btns no-mobile">
                    <div data-modal-action="open" data-modal-target="main-menu" class="open-menu">
                        Menu <img src="images/open-menu.svg" alt="" />
                    </div>
                </div>

                <div data-modal-action="toggle" data-modal-target="main-menu" class="mobile-only open-mobile-menu">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </header>



            <div data-modal-name="main-menu" data-modal-type="main-menu" data-modal-timeline="500" data-modal-custom-layer="">
                <div class="content pad-mobile">
                    <div class="close-x" data-modal-action="close"></div>
                    <div data-lavalamp=""></div>
                    <div class="links no-mobile">
                        <a href="Home"><span>Home</span></a>
                        <a href="About"><span>About us</span></a>
                        <a href="#"><span>Blog</span></a>

                    </div>


                    <div class="mobile-mega-menu mobile-only">
                        <div data-slider="mega-menu" data-slider-auto-height="" data-slider-auto-height-throlle=".4s">
                            <div data-slide-name="main" class="main">
                                <div class="logo"><img src="images/logo.png" /></div>
                                <div class="main">
                                    <a href="nucoin"><span data-slider-target="mega-menu" >NuCoin</span> </a>
                                    <a href="LedgerX"><span data-slider-target="mega-menu" >LedgerX</span> </a>
                                    <a href="Insidecrypto"><span data-slider-target="mega-menu" >Inside Crypto</span> </a>
                                    <a href="Roadmap"><span data-slider-target="mega-menu" >Roadmap</span> </a>
                                    <a href="explorer"><span data-slider-target="mega-menu" >Explorer</span> </a>
                                    <a href="explorer_transection"><span data-slider-target="mega-menu" >NuCoin 1 Explorer History</span> </a>
                                    <a href="sell_nuc"><span data-slider-target="mega-menu" >Sell NUC</span> </a>
                                    {/* <a href="Facebook"><span data-slider-target="mega-menu" >Facebook</span> </a> */}
                                    <span data-slider-target="mega-menu" data-slider-select-slide="menu-0">About Us<i></i></span>
                                    <span data-slider-target="mega-menu" data-slider-select-slide="menu-1">AI Application<i></i></span>
                                    <span data-slider-target="mega-menu" data-slider-select-slide="menu-2">{process.env.REACT_APP_PROJECT_NAME} Pitch Deck<i></i></span>
                                    {/* <span data-slider-target="mega-menu" data-slider-select-slide="menu-3">Foundation<i></i></span>
                                    <span data-slider-target="mega-menu" data-slider-select-slide="right-menu">Menu<i></i></span> */}
                                </div>
                            </div>

                            <div data-slide-name="menu-0" class="web3back">

                                <div class="child">
                                    <span data-slider-target="mega-menu" data-slider-select-slide="main" class="back"></span>
                                    <div class="title">About Us</div>
                                    <div class="list">
                                        <a href="About">About {process.env.REACT_APP_PROJECT_NAME}</a>
                                        <a href="Projects">Projects</a>
                                        <a href="Facebook">Facebook</a>
                                        {/*<a href="#">Getting Involved</a>
                                        <a href="#">Opportunities</a> */}
                                    </div>
                                    <div class="btns">

                                    </div>
                                </div>
                            </div>

                            <div data-slide-name="menu-1" class="web3back">

                                <div class="child">
                                    <span data-slider-target="mega-menu" data-slider-select-slide="main" class="back"></span>
                                    <div class="title">AI Application</div>
                                    <div class="list">
                                        <a href="CryptoInsightsBot">Crypto Insights Bot</a>
                                        <a href="crypto_compare">Crypto Compare</a>
                                        <a href="textanalyze">AI Detector</a>
                                        <a href="InsightsCryptoNewsHub">InsideCrypto News Hub</a>
                                        <a href="dreamInterpretation">Dream Interpretation</a>
                                        <a href="digitalkyc">Digital kyc</a>
                                        <a href="deepfake">Deepfake</a>
                                        <a href="cryptotutor">Crypto Trading Tutor</a>
                                        <a href="textsummarize">AI Text Summarizer</a>
                                        <a href="textparaphrase">AI Text Paraphrasing</a>
                                        <a href="textgrammer">AI Grammar Checker</a>
                                        <a href="lawyer">AI Lawyer</a>
                                        <a href="fitness">AI Fitness</a>
                                        <a href="tutor">AI Tutor</a>
                                        <a href="chefmate">ChefMate</a>
                                        <a href="chatscraper">Chat Scraper</a>
                                        <a href="chatty">Chatty</a>

                                    </div>
                                    <div class="btns">

                                    </div>
                                </div>
                            </div>

                            <div data-slide-name="menu-2" class="web3back">

                                <div class="child">
                                    <span data-slider-target="mega-menu" data-slider-select-slide="main" class="back"></span>
                                    <div class="title">{process.env.REACT_APP_PROJECT_NAME} Pitch Deck</div>
                                    <div class="list">
                                        <a href="community">NuGensis Community </a>
                                        <a href="valuation_report">Valuation Report</a>
                                        <a href="pdg">Pitch Deck Guide</a>
                                        <a href="ti_department">Technology Innovations Department</a>
                                        <a href="medical">Medical Field</a>
                                        <a href="ai_department">Artificial Innovation Department</a>
                                        <a href="summary">Summary And Rejuvenation Plan</a>
                                        <a href="nft">NFTS</a>
                                        <a href="prediction">Prediction & Analytics</a>
                                        <a href="media_stream">Media Stream</a>
                                        <a href="business_resources">Business Resources</a>
                                        <a href="videos">Videos Series</a>


                                    </div>
                                    <div class="btns">

                                    </div>
                                </div>
                            </div>


                            <div data-slide-name="right-menu">
                                <div class="child">
                                    <span data-slider-target="mega-menu" data-slider-select-slide="main" class="back"></span>
                                    <div class="title">Menu</div>
                                    <div class="list">
                                        <a href="Home">Home</a>
                                        <a href="About">About us</a>
                                        <a href="#">Blog</a>

                                    </div>
                                    <div class="btns">

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <a href="Home"><span class="logo-fixed" href="/"><img src="images/logo-text.png?v-1" alt="" /></span></a>
        </>
    );
}

